<template>
  <div v-if="isAtLimit" class="photo-limit-warning">
    You've reached the limit for this post ({{ MAX_PHOTOS_PER_POST }} max)
  </div>
</template>

<script setup lang="ts">
import { MAX_PHOTOS_PER_POST } from "@/constants/social";

defineProps<{
  isAtLimit: boolean;
}>();
</script>

<style scoped lang="scss">
.photo-limit-warning {
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  background: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.6);
  border-radius: 6px;
  color: #856404;
  font-weight: 600;
  text-align: center;
}
</style>
